import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { CompleteTranslationFieldsFragmentDoc } from '@/experiences/sales-portal/blocs/documents/sales-portal-translation-fragments.generated';
import { gql } from '@apollo/client';
import { SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc } from './sales-portal-order-entry-item-fields.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalCatalogSearchDocument = gql`
  query SalesPortalCatalogSearch(
    $supplierUUID: uuid!
    $restaurantUUID: uuid!
    $deliveryDate: String
    $searchTerm: String!
  ) {
    searchCatalogForOrderEntryItems(
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
      delivery_date: $deliveryDate
      search_term: $searchTerm
    ) {
      price_edit_display_headers {
        key
        is_confidential
        category
        translation {
          ...CompleteTranslationFields
        }
      }
      order_entry_items {
        ...SalesPortalOrderEntryTable_OrderEntryItemFields
      }
    }
  }
  ${CompleteTranslationFieldsFragmentDoc}
  ${SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc}
`;
export function useSalesPortalCatalogSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >(SalesPortalCatalogSearchDocument, options);
}
export function useSalesPortalCatalogSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >(SalesPortalCatalogSearchDocument, options);
}
export type SalesPortalCatalogSearchQueryHookResult = ReturnType<
  typeof useSalesPortalCatalogSearchQuery
>;
export type SalesPortalCatalogSearchLazyQueryHookResult = ReturnType<
  typeof useSalesPortalCatalogSearchLazyQuery
>;
export type SalesPortalCatalogSearchQueryResult = Apollo.QueryResult<
  Types.SalesPortalCatalogSearchQuery,
  Types.SalesPortalCatalogSearchQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalCatalogSearchQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalCatalogSearchQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >(SalesPortalCatalogSearchDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalCatalogSearchLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalCatalogSearchLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalCatalogSearchQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalCatalogSearchQuery,
    Types.SalesPortalCatalogSearchQueryVariables
  >(SalesPortalCatalogSearchDocument, lazyOptions);
}
